import React from 'react'
import { connect } from 'react-redux'

import OptionList from '../option-list'
import { sortOptions } from '../../../utils/option-sort'

const mapStateToProps = (state) => {
    return {
        options: sortOptions(state.adminOccasions)
    }
}

const Occasions = ({ options }) => {
    return (
        <OptionList
            endpoint="admin/occasions"
            options={options}
            singular="Occasion" />
    )
}

export default connect(mapStateToProps)(Occasions)
